import { doc, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "@/lib/firebase";

export function dm2ThreadId(a: string, b: string): string {
  const pair = a < b ? `${a}_${b}` : `${b}_${a}`;
  return `dm2:${pair}`;
}

export async function ensureDmThreadFor(aUid: string, bUid: string) {
  const tid = dm2ThreadId(aUid, bUid);
  const participants = [aUid, bUid].sort((x, y) => (x < y ? -1 : 1));
  await setDoc(
    doc(db, "threads_v2", tid),
    {
      participants,
      visibleFor: participants,
      lastMessageAt: serverTimestamp(),
      unreadCounts: { [aUid]: 0, [bUid]: 0 },
      tab: "inbox",
    },
    { merge: true }
  );
  return tid;
}
